module.exports = __webpack_public_path__ + "static/media/loc7_img7.a3c0cf90.jpg";